import Swiper, { A11y, Navigation } from 'swiper';
import wishlist from '../utils/_wishlist';

class mRecoSlider extends HTMLDivElement {
    constructor() {
        super();
        this.slider = null;
    }

    connectedCallback() {
        // TODO: use classes instead
        this.sliderIsInsideSidebar = this.closest('[is="o-sidebar-ajax"]') !== null;
        this.sliderInInsideCart = this.closest('[is="o-cart"]') !== null;
        const isSliderFormat = !this.classList.contains('list-format');

        if (this.sliderIsInsideSidebar) {
            this.sliderMaxSlidesPerView = 2.2;
            this.sliderBreakpoints = null;
        } else {
            this.sliderBreakpoints = {
                480: {
                    slidesPerView: 2.5
                },
                768: {
                    slidesPerView: 3.5
                },
                1024: {
                    slidesPerView: 4
                }
            };

            this.sliderMaxSlidesPerView = 4;
        }
        isSliderFormat && this.initSlider();
    }

    /**
     * Populate slider with cloned slides if there is not enough slides
     * @param {number} minSlides - Minimum number of slides that the slider must contains
     */
    fillSlider(minSlides) {
        const wrapper = this.querySelector('.swiper-wrapper');
        const slides = wrapper.querySelectorAll('.swiper-slide');
        if (slides.length === 0) return;

        const sliderCloningNb = Math.ceil(minSlides / slides.length) - 1;
        for (let i = 0; i < sliderCloningNb; ++i) {
            slides.forEach((slide) => {
                wrapper.appendChild(slide.cloneNode(true));
            });
        }
    }

    initSlider() {
        const slidesCount = this.querySelectorAll('.swiper-slide').length;
        let loop = false;
        if (
            slidesCount > this.sliderMaxSlidesPerView &&
            slidesCount < this.sliderMaxSlidesPerView * 2
        ) {
            // allow looping
            this.fillSlider(this.sliderMaxSlidesPerView * 2);
            loop = true;
        } else if (slidesCount >= this.sliderMaxSlidesPerView * 2) {
            loop = true;
        }

        this.slider = new Swiper(this, {
            modules: [A11y, Navigation],
            spaceBetween: -0.5,
            slidesPerView: 2.2,
            breakpoints: this.sliderBreakpoints,
            loop, // can only loop correctly if slidesCount >= slidesPerView * 2
            allowTouchMove: true,
            touchStartPreventDefault: false,
            threshold: 20,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            },
            a11y: {
                prevSlideMessage: this.dataset.a11ySlidePrev,
                nextSlideMessage: this.dataset.a11ySlideNext
            }
        });

        wishlist.activateWishlistHeartButtons();
    }
}

customElements.define('m-reco-slider', mRecoSlider, {
    extends: 'div'
});
